// datagridextensions.js
// (c) 2015 EvoluS Srl Torino
// (a) Vittorio Giura

$.extend($.fn.datagrid.defaults.editors, {
	nxtextbox: {
		init: function (container, options) {
			var input = $('<input type="text" class="datagrid-editable-input">');
			input.appendTo(container);
			// prima si crea la textbox easyui
			var retval = input.textbox(options);
			// poi si modifica il comportamento dell'elemento di input
			var t = retval.textbox('textbox');
			if (options.maxlen) {
				t.attr('maxlength', options.maxlen);
			}
			return retval;
		},
		destroy: function (target) {
			$(target).textbox('destroy');
		},
		getValue: function (target) {
			var value = $(target).textbox('getValue');
			if (!value) value = null
			return value;
		},
		setValue: function (target, value) {
			var ed = $(target);
			ed.textbox('setValue', value);
		},
		resize: function (target, width) {
			$(target).textbox('resize', width);
		}
	},
	nxuppercasetextbox: {
		init: function (container, options) {
			var input = $('<input type="text" class="datagrid-editable-input">')
			input.appendTo(container)
			// prima si crea la textbox easyui
			var retval = input.textbox(options)
			// poi si modifica il comportamento dell'elemento di input
			var t = retval.textbox('textbox')
			t.css('text-transform', 'uppercase')
			if (options.maxlen) {
				t.attr('maxlength', options.maxlen)
			}
			return retval
		},
		destroy: function (target) {
			$(target).textbox('destroy')
		},
		getValue: function (target) {
			var value = $(target).textbox('getValue')
			if (!value) value = null
			if (value) value = value.toUpperCase()
			return value;
		},
		setValue: function (target, value) {
			var ed = $(target);
			ed.textbox('setValue', value)
		},
		resize: function (target, width) {
			$(target).textbox('resize', width)
		}
	},
	nxcodetextbox: {
		init: function (container, options) {
			var input = $('<input type="text" class="datagrid-editable-input">');
			input.appendTo(container);
			// prima si crea la textbox easyui
			var retval = input.textbox(options);
			// poi si modifica il comportamento dell'elemento di input
			var t = retval.textbox('textbox');
			if (options.maxlen) {
				t.attr('maxlength', options.maxlen);
			}
			t.on('keypress', function (event) {
				// solo numeri e il punto
				if (event.charCode < 32) return true
				if ((event.charCode < 48) || (event.charCode > 57)) {
					if (event.charCode !== 46) return false // punto
				}
				return true
			})
			return retval;
		},
		destroy: function (target) {
			$(target).textbox('destroy');
		},
		getValue: function (target) {
			var value = $(target).textbox('getValue');
			if (!value) value = null
			return value;
		},
		setValue: function (target, value) {
			$(target).textbox('setValue', value)
		},
		resize: function (target, width) {
			$(target).textbox('resize', width)
		}
	},
	nxnumberbox: {
		init: function (container, options) {
			var input = $('<input type="text" class="datagrid-editable-input">').appendTo(container)
			var retval = input.textbox(options)
			var t = retval.textbox('textbox')
			if (options.maxlen) {
				t.attr('maxlength', options.maxlen);
			}
			t.on('keypress', function (event) {
				// solo numeri e la virgola
				if (event.charCode < 32) return true
				if ((event.charCode < 48) || (event.charCode > 57)) {
					if (event.charCode !== 44) return false // virgola
				}
				return true
			})
			return retval;
		},
		destroy: function (target) {
			$(target).textbox('destroy')
		},
		getValue: function (target) {
			var value = $(target).textbox('getValue');
			if (!value) value = null
			value = value.replace('.',',')
			return value;
		},
		setValue: function (target, value) {
			value = value.replace(',','.')
			$(target).textbox('setValue', value)
		},
		resize: function (target, width) {
			$(target).textbox('resize', width)
		}
	},
	nxintegerbox: {
		init: function (container, options) {
			var input = $('<input type="text" class="datagrid-editable-input">')
			input.appendTo(container)
			var retval = input.textbox(options)
			var t = retval.textbox('textbox')
			if (options.maxlen) {
				t.attr('maxlength', options.maxlen);
			}
			t.on('keypress', function (event) {
				// solo numeri
				if (event.charCode < 32) return true
				if ((event.charCode < 48) || (event.charCode > 57)) {
					return false
				}
				return true
			})
			return retval;
		},
		destroy: function (target) {
			$(target).textbox('destroy')
		},
		getValue: function (target) {
			var value = $(target).textbox('getValue');
			if (!value) value = null
			return value;
		},
		setValue: function (target, value) {
			$(target).textbox('setValue', value)
		},
		resize: function (target, width) {
			$(target).textbox('resize', width)
		}
	},
	nxcheckbox: {
		init: function (container, options) {
			var input = $('<input type="checkbox"></input>').appendTo(container)
			input.checkbox()
			let color = input.parent().find('.checkbox').css('border-color')
			input.parent().find('.checkbox').css('background-color', color)
			let inner = input.parent().find('.checkbox-value')
			// inner.on('keydown', (event) => {
			// 	console.log(event.which)
			// })
			inner.attr('tabindex', 1)
			setTimeout(() => {
				inner.focus()
			}, 0)
			return input
		},
		destroy: function (target) {
			$(target).remove();
		},
		getValue: function (target) {
			let value = $(target).checkbox('options').checked
			return value
		},
		setValue: function (target, value) {
			// $(target).checkbox('setValue',value )
			// target[0].checked = value ? value : false
			// $(target).checkbox('setValue', value)

			if (value) {
				$(target).checkbox('check')
				$(target).checkbox('setValue', true)
			}
			else {
				$(target).checkbox('uncheck')
				$(target).checkbox('setValue', false)
			}
		},
		resize: function (target, width) {
			$(target)._outerWidth(width)
		}
	},
	nxcombobox: {
		init: function (container, options) {
			var div = $('<div class="datagrid-editable-input"></div>').appendTo(container)
			// var localoptions = {
			// 	textField: 'disp',
			// 	valueField: 'val'
			// }
			// Object.assign(localoptions, options)
			let t = div.combobox(options)
			// let innerHost = this.host.combobox('textbox')
			return div
		},
		destroy: function (target) {
			$(target).combobox('destroy')
		},
		getValue: function (target) {
			return $(target).combobox('getValue')
		},
		setValue: function (target, value) {
			return $(target).combobox('setValue', value)
		},
		resize: function (target, width) {
			$(target).combobox('resize', width)
		}
	},
	nxdatebox: {
		init: function (container, options) {
			let focused = 'day'
			// evento keypress
			function onkeypress(target, event, month, year) {
				let start = event.target.selectionStart
				let end = event.target.selectionEnd
				let isSelected = (start !== end)
				let text = event.target.value
				let len = text ? text.length : 0
				if (event.which > 57) return false
				if ((event.which < 48) && (event.which != 13)) return false
				let val = event.which - 48
				if ((len === 0) || isSelected) {
					switch (focused) {
						case 'day':
							if (val > 3) {
								setTimeout(() => { month.focus(); month.select() }, 0)
							}
							break
						case 'month':
							if (val > 1) {
								setTimeout(() => { year.focus(); year.select() }, 0)
							}
					}
				}
				else if ((len > 0) && !isSelected) {
					switch (focused) {
						case 'day':
							setTimeout(() => { month.focus(); month.select() }, 0)
							break
						case 'month':
							setTimeout(() => { year.focus(); year.select() }, 0)
					}
				}
				return true
			}
			// evento keydown
			function onkeydown(target, event, day, month) {
				// console.log('keydown: '+event.which)
				let start = event.target.selectionStart
				let end = event.target.selectionEnd
				let isSelected = (start !== end)
				let text = event.target.value
				let len = text ? text.length : 0
				if (event.which === 27) {
					// this.control.reset(this.initialValue)
					// this.control.control.markAsPristine()
					// this.control.control.markAsUntouched()
					// event.stopPropagation()
				}
				if ((event.which === 39) && ((start === len) || isSelected)) {
					// a destra
					if (focused === 'day') setTimeout(() => { month.focus(); month.select() }, 0)
					if (focused === 'month') setTimeout(() => { year.focus(); year.select() }, 0)
				}
				if ((event.which === 37) && (start === 0)) {
					// a sinistra
					if (focused === 'month') setTimeout(() => { day.focus(); day.select() }, 0)
					if (focused === 'year') setTimeout(() => { month.focus(); month.select() }, 0)
				}
				if (event.which === 13) target.getValue(input)
			}
			// eventi focus
			function onfocusday() {
				focused = 'day'
			}
			function onfocusmonth() {
				focused = 'month'
			}
			function onfocusyear() {
				focused = 'year'
			}
			// template dell'oggetto data
			let input = $(`
				<div class="nxdatebox" style="position: relative;">
					<div class="textbox" style="white-space: nowrap;">
						<input type="text" class="day" maxlength="2" style="width: 17px;">
						<div class="slash">/</div>
						<input type="text" class="month" maxlength="2" style="width: 17px;">
						<div class="slash">/</div>
						<input type="text" class="year" maxlength="4" style="width: 34px;">
						<div class="calbutton" tyle="float: right; margin-top: 1px"></div>
						<div class="clearbutton" style="float: right"></div>
						<div class="tooltip"></div>
					</div>
					<div class="calendar" style="position: absolute; z-index: 10010"></div>
				</div>
			`)
			input.appendTo(container)
			// configura eventi
			let day = input.find('.day')
			let month = input.find('.month')
			let year = input.find('.year')
			day.on('keypress', (event) => onkeypress(this, event, month, year))
			day.on('keydown', (event) => onkeydown(this, event, day, month))
			day.on('focus', () => onfocusday())
			day.on('blur', () => this.getValue(input))
			month.on('keypress', (event) => onkeypress(this, event, month, year))
			month.on('keydown', (event) => onkeydown(this, event, day, month))
			month.on('focus', () => onfocusmonth())
			month.on('blur', () => this.getValue(input))
			year.on('keypress', (event) => onkeypress(this, event, month, year))
			year.on('keydown', (event) => onkeydown(this, event, day, month))
			year.on('focus', () => onfocusyear())
			year.on('blur', () => this.getValue(input))
			setTimeout(() => { day.select() }, 0)
			return input;
		},
		destroy: function (target) {
			let day = $(target).find('.day')
			let month = $(target).find('.month')
			let year = $(target).find('.year')
		},
		getValue: function (target) {
			// convalida e conversione da D, M, Y a valore PG
			function updateValue() {
				// convalido i valori dei tre campi
				let day = Number(dmday)
				let dayok = false
				if (day && (day !== NaN) && (day > 0)) dayok = true
				let month = Number(dmmonth)
				let monthok = false
				if (month && (month !== NaN) && (month >= 0)) monthok = true
				let year = Number(dmyear)
				let yearok = false
				if (year && (year !== NaN) && (year > 0)) yearok = true
				if (dayok && (day < 10) && (day > 0)) {
					dmday = '0' + day
				}
				if (monthok && (month < 10) && (month > 0)) {
					dmmonth = '0' + month
				}
				let time = target.dmtime
				if (!time) {
					time = '00:00:00'
				}
				let newValue = Globs.dataIsoToJs(`${dmyear}-${dmmonth}-${dmday} ${time}`)
				let isValid = (newValue !== null) && isValidDate(day, month, year)
				//console.log('Valore originale: '+this.initialValue)
				//console.log('Nuovo valore JS: '+newValue.toString())
				//console.log('Nuovo valore ISO: '+Globs.dataJsToPg(newValue))
				// if (dmyear && dmmonth && dmday) {
				// 	this.setTooltip(!isValid)
				// }
				// else {
				// 	this.setTooltip(false)
				// }

				let retVal = null
				if (isValid) {
					let newStr = newValue ? dataJsToPg(newValue) : ''
					// this.hostCalendar.calendar('moveTo', this.dataModel)
					if (target.dmtime) {
						newStr = `${newStr} ${target.dmtime}`
					}
					//console.log('Nuovo valore DM: '+newStr)
					retVal = newStr
				}
				else {
					throw 'data non valida'
				}
				return retVal
			}

			// GETVALUE ...
			let day = $(target).find('.day')
			let month = $(target).find('.month')
			let year = $(target).find('.year')
			let dmday = day.val()
			let dmmonth = month.val()
			let dmyear = year.val()
			let value = updateValue()
			day.val(dmday)
			month.val(dmmonth)
			year.val(dmyear)
			return value
		},
		setValue: function (target, value) {
			let dmday, dmmonth, dmyear
			// conversione da JS a D, M, Y
			function setDMY(date) {
				if (date instanceof Date) {
					let sday = date.getDate().toString()
					if (sday.length === 1) dmday = '0' + sday
					else dmday = sday
					let smonth = (date.getMonth() + 1).toString()
					if (smonth.length === 1) dmmonth = '0' + smonth
					else dmmonth = smonth
					dmyear = date.getFullYear().toString()
					// this.hostCalendar.calendar('moveTo', dataModel)
				}
				else {
					dmday = ''
					dmmonth = ''
					dmyear = ''
				}
			}
			// SETVALUE....
			// value deve essere in formato PG (ISO)  yyyy-mm-ddTHH:MM:SS
			let date = null
			let dmtime = ''
			if (value) {
				date = Globs.dataIsoToJs(value)
				if (value.length > 11) {
					dmtime = value.substring(11) // NB: da char 11 alla fine della stringa compresi i tick se presenti
				}
			}
			setDMY(date)
			let day = $(target).find('.day')
			let month = $(target).find('.month')
			let year = $(target).find('.year')
			day.val(dmday)
			month.val(dmmonth)
			year.val(dmyear)
			target.dmtime = dmtime
		},
		resize: function (target, width) {
			$(target)._outerWidth(width)
		}
	},
	nxtimebox: {
		init: function (container, options) {
			let focused = 'hour'
			// evento keypress
			function onkeypress(target, event, min, sec) {
				let start = event.target.selectionStart
				let end = event.target.selectionEnd
				let isSelected = (start !== end)
				let text = event.target.value
				let len = text ? text.length : 0
				if (event.which > 57) return false
				if ((event.which < 48) && (event.which != 13)) return false
				let val = event.which - 48
				if ((len === 0) || isSelected) {
					switch (focused) {
						case 'hour':
							if (val > 2) {
								setTimeout(() => { min.focus(); min.select() }, 0)
							}
							break
						case 'min':
							if (val > 5) {
								setTimeout(() => { sec.focus(); sec.select() }, 0)
							}
						case 'sec':
							if (val > 5) {
								target.getValue(input)
							}
					}
				}
				else if ((len > 0) && !isSelected) {
					switch (focused) {
						case 'hour':
							setTimeout(() => { min.focus(); min.select() }, 0)
							break
						case 'min':
							setTimeout(() => { sec.focus(); sec.select() }, 0)
						// 	break
						// case 'sec':
						// 	target.getValue(input)
					}
				}
				return true
			}
			// evento keydown
			function onkeydown(target, event, hour, min, sec) {
				// console.log('keydown: '+event.which)
				let start = event.target.selectionStart
				let end = event.target.selectionEnd
				let isSelected = (start !== end)
				let text = event.target.value
				let len = text ? text.length : 0
				if (event.which === 27) {
					// this.control.reset(this.initialValue)
					// this.control.control.markAsPristine()
					// this.control.control.markAsUntouched()
					// event.stopPropagation()
				}
				if ((event.which === 39) && ((start === len) || isSelected)) {
					// a destra
					if (focused === 'hour') setTimeout(() => { min.focus(); min.select() }, 0)
					if (focused === 'min') setTimeout(() => { sec.focus(); sec.select() }, 0)
				}
				if ((event.which === 37) && (start === 0)) {
					// a sinistra
					if (focused === 'min') setTimeout(() => { hour.focus(); hour.select() }, 0)
					if (focused === 'sec') setTimeout(() => { min.focus(); min.select() }, 0)
				}
				if (event.which === 13) target.getValue(input)
			}
			// eventi focus
			function onfocushour() {
				focused = 'hour'
			}
			function onfocusmin() {
				focused = 'min'
			}
			function onfocussec() {
				focused = 'sec'
			}
			// template dell'oggetto data
			let input = $(`
				<div class="nxdatebox" style="position: relative;">
					<div class="textbox" style="padding: 0 0 0 3px; white-space: nowrap">
						<input type="text" style="width: 17px" class="hour" maxlength="2">
						<div class="slash">:</div>
						<input type="text" style="width: 17px" class="min" maxlength="2">
						<div class="slash">:</div>
						<input type="text" style="width: 17px" class="sec" maxlength="2">
						<div class="clearbutton" style="float: right"></div>
						<div class="tooltip"></div>
					</div>
				</div>
			`)
			input.appendTo(container)
			let hour = input.find('.hour')
			let min = input.find('.min')
			let sec = input.find('.sec')
			hour.on('keypress', (event) => onkeypress(this,event,min,sec))
			hour.on('keydown', (event) => onkeydown(this,event,hour,min,sec))
			hour.on('focus', () => onfocushour())
			hour.on('blur', () => this.getValue(input))
			min.on('keypress', (event) => onkeypress(this,event,min,sec))
			min.on('keydown', (event) => onkeydown(this,event,hour,min,sec))
			min.on('focus', () => onfocusmin())
			min.on('blur', () => this.getValue(input))
			sec.on('keypress', (event) => onkeypress(this,event,min,sec))
			sec.on('keydown', (event) => onkeydown(this,event,hour,min,sec))
			sec.on('focus', () => onfocussec())
			sec.on('blur', () => this.getValue(input))
			setTimeout(() => { hour.focus(); hour.select() }, 0)
			return input
		},
		destroy: function (target) {
			let hour = $(target).find('.hour')
			let min = $(target).find('.min')
			let sec = $(target).find('.sec')
		},
		getValue: function (target) {
			function updateValue() {
				// convalido i valori dei tre campi
				let hour = Number(dmhour)
				let hourok = false
				if (hour && (hour !== NaN)) hourok = true
				if ((hour < 0) || (hour > 23)) hourok = false
				if (hourok && (hour < 10) && (hour >= 0)) {
					dmhour = '0' + hour
				}
				let min = Number(dmmin)
				let minok = false
				if (min && (min !== NaN)) minok = true
				if ((min < 0) || (min > 59)) minok = false
				if (minok && (min < 10) && (min >= 0)) {
					dmmin = '0' + min
				}
				let sec = Number(dmsec)
				let secok = false
				if (sec && (sec !== NaN)) secok = true
				if ((sec < 0) || (sec > 59)) secok = false
				if (secok && (sec < 10) && (sec >= 0)) {
					dmsec = '0' + sec
				}
				let date = target.dmdate
				if (!date) {
					date = '1980-01-01'
				}

				let newValue = Globs.dataIsoToJs(`${date} ${dmhour}:${dmmin}:${dmsec}`)
				let isValid = (newValue !== null) && isValidHour(hour, min, sec)
				//console.log('Valore originale: '+this.initialValue)
				//console.log('Nuovo valore JS: '+newValue.toString())
				//console.log('Nuovo valore ISO: '+Globs.dataJsToPg(newValue))
				// if (dmhour && dmmin && dmsec) {
				// 	this.setTooltip(!isValid)
				// }
				// else {
				// 	this.setTooltip(false)
				// }

				let retval = null
				if (isValid) {
					retval = newValue ? `${date} ${dmhour}:${dmmin}:${dmsec}` : ''
				}
				else {
					throw 'data non valida'
				}
				return retval
			}
			// GETVALUE ...
			let hour = $(target).find('.hour')
			let min = $(target).find('.min')
			let sec = $(target).find('.sec')
			let dmhour = hour.val()
			let dmmin = min.val()
			let dmsec = sec.val()
			let value = updateValue()
			hour.val(dmhour)
			min.val(dmmin)
			sec.val(dmsec)
			return value
		},
		setValue: function (target, value) {
			let dmhour, dmmin, dmsec
			// estrae dalla data l'ora il minuto e i secondi
			function setHMS(date) {
				if (date instanceof Date) {
					let shour = date.getHours().toString()
					if (shour.length === 1) dmhour = '0' + shour
					else dmhour = shour
					let smin = date.getMinutes().toString()
					if (smin.length === 1) dmmin = '0' + smin
					else dmmin = smin
					let ssec = date.getSeconds().toString()
					if (ssec.length === 1) dmsec = '0' + ssec
					else dmsec = ssec
				}
				else {
					dmhour = ''
					dmmin = ''
					dmsec = ''
				}
			}
			// SETVALUE.....
			let date = null
			let dmdate = ''
			if (value) {
				date = Globs.dataIsoToJs(value)
				if (value.length >= 10) {
					dmdate = value.substr(0,10)
				}
			}
			target.initialIsoValue = value
			setHMS(date)
			let hour = $(target).find('.hour')
			let min = $(target).find('.min')
			let sec = $(target).find('.sec')
			hour.val(dmhour)
			min.val(dmmin)
			sec.val(dmsec)
			target.dmdate = dmdate
		},
		resize: function (target, width) {
			$(target)._outerWidth(width)
		}
	},
	nxcampodropdown: {
		init: function (container, options) {
			var dm = 'dm';
			if (options.dmodel !== undefined) {
				dm = options.dmodel;
			}
			var input = $("<div easyui-datetimespinner ng-model='" + dm + "'></div>");
			input.appendTo(container);
			if (options.compile !== undefined) {
				options.compile(input);
			}
			return input;
		},
		destroy: function (target) {
			$(target).remove();
		},
		getValue: function (target) {
			return ''; //$(target).prop('checked');
		},
		setValue: function (target, value) {
			//$(target).prop('checked',value);
		},
		resize: function (target, width) {
			$(target)._outerWidth(width);
		}
	}
});



// WEBPACK FOOTER //
// src/assets/js/datagridextensions.js